export default function AutofocusDirective($timeout) {
	'ngInject';

	return {
		restrict: 'A',
		link: function($scope, $element) {
			$timeout(function() {
				$element[0].focus();
			}, 1000);
		}
	};
}
